import React, { useEffect, useState } from 'react';
import { Card, Form, Image, Row, Col, Modal, Button } from 'react-bootstrap';
import './ClothPriceStep.css';
import tShirt from '../../../../Assets/t-shirt.jpg';
import tUpper from '../../../../Assets/Upper.jpg';

const imgUrl = tShirt;
const imgUrl1 = tUpper;
const clothOptions = [
  { id: '1', name: 'T-Shirt', image: imgUrl },
  { id: '2', name: 'Upper',image: imgUrl1 }
];

const TypeStep = ({selectedType,setSelectedType,quote}) => {  
  const [modalImage, setModalImage] = useState(null);

  const handleImageClick = (img) => setModalImage(img);
  const handleClose = () => setModalImage(null);

  useEffect(() => {
    if(quote?.length > 0){      
      if(parseInt(quote?.[0]?.quote_type) === 2){
        setSelectedType(clothOptions[1].id)
      }else{setSelectedType(clothOptions[0].id)}      
    }
    else if(selectedType === '' || selectedType===undefined){
      setSelectedType(clothOptions[0].id)
    }
  },[quote])
  

  return (
    <>
      <div className="cloth-list-wrapper">
        {clothOptions.map((item) => (
          <Card
            key={item.id}            
            className={`cloth-card mb-2 ${selectedType === item.id ? 'selected' : ''} ${quote?.length > 0 ? 'disabled' : ''}`}
            onClick={() => setSelectedType(item.id)}
            
          >
            <Card.Body className="p-2 position-relative">
              <Form.Check
                
                type="radio"
                id={item.id}
                name="clothId"
                value={item.id}
                checked={selectedType === item.id}
                onChange={() => setSelectedType(item.id)}
                className="cloth-radio"
              />
              <Row className="align-items-center">
                <Col xs={4} className="text-center">
                  <Image
                    src={item.image}
                    rounded
                    className="cloth-image"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleImageClick(item.image);
                    }}
                  />
                </Col>
                <Col xs={8} className="cloth-info">
                  <div className="fw-semibold">{item.name}</div>                  
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
      </div>

      <Modal show={!!modalImage} onHide={handleClose} centered>
        <Button
          variant="light"
          onClick={handleClose}
          className="modal-close-btn"
        >
          &times;
        </Button>
        <Modal.Body className="p-0 text-center modal-image-body">
          <Image src={modalImage} className="modal-image" />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TypeStep;
